import { IconMiniButton } from 'components/FbUI/FbButton'
import CreateCompanyButton from 'components/Modals/CompanyModal/CreateCompanyButton'
import { CreateDoorProxyModal } from 'components/Modals/CompanyModal/CreateDoorProxyModal'
import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { BsDownload } from 'react-icons/bs'
import { CompanyTypeSlug } from '../../models/companies'
import { IContactCompany } from '../../models/contact_companies'

interface OpportunitiesTableFooterControlsProps {
  companyTypeSlug?: CompanyTypeSlug
  onDownloadButtonClick: () => void
  hideCreateCompanyButton?: boolean
  /**
   * When provided, shows "Create Door" button instead of "Create Company" button.
   * This is used when viewing doors within a specific company context.
   */
  chainProxy?: IContactCompany
  /**
   * Table key for the unmatched doors table. Used to invalidate/refetch queries
   * when a new door is created.
   */
  unmatchedTableKey?: string
}

const OpportunitiesTableFooterControls: React.FC<
  OpportunitiesTableFooterControlsProps
> = ({
  companyTypeSlug,
  onDownloadButtonClick,
  hideCreateCompanyButton,
  chainProxy,
  unmatchedTableKey,
}) => {
  const showCreateButton = !hideCreateCompanyButton && companyTypeSlug

  return (
    <>
      {showCreateButton && chainProxy ? (
        <CreateDoorProxyModal
          chainProxy={chainProxy}
          unmatchedTableKey={unmatchedTableKey}
          iconOnly
        />
      ) : showCreateButton ? (
        <CreateCompanyButton companyTypeSlug={companyTypeSlug} />
      ) : null}
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-download">
            Download limited to 10,000 rows
          </Tooltip>
        }
      >
        <div>
          <IconMiniButton onClick={onDownloadButtonClick}>
            <BsDownload size={18} />
          </IconMiniButton>
        </div>
      </OverlayTrigger>
    </>
  )
}

export default OpportunitiesTableFooterControls
